export function DocumentWebView({ html, title }: { html: string; title: string }) {
    return (
        <iframe
            title={title}
            srcDoc={html}
            sandbox="allow-scripts"
            style={{ flex: 1, width: "100%", border: 0, background: "#f3f5f8" }}
        />
    );
}
